import React, {useEffect, useState} from "react";
import WelSnapVideo from "../components/freeVideo/WelSnapVideo";
import ExampleVideos from "../components/freeVideo/ExampleVideos";
import GetYourFree from "../components/freeVideo/GetYourFree";
import WantToDiscuss from "../components/freeVideo/WantToDiscuss";
import headerLogo from "../assets/images/landing-header.png";
import { KeyboardArrowUp } from '@mui/icons-material';

function FreeVideo() {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        const scrollY = window.scrollY;
        const rootElement = document.getElementById("root");

        if (rootElement) {
          if (scrollY >= 70) {
            rootElement.classList.add("sticky");
          } else {
            rootElement.classList.remove("sticky");
          }
        }

        if (scrollY > 100) {
          setShowScroll(true);
        } else {
          setShowScroll(false);
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <div id="wrapper" className="landing-page">
        {/* <!-- start-header --> */}

        <header id="header" class="landing-header free-video-header">
          <div class="row ">
            <div class="header-section ">
              <div class="container">
                <div class="header-wrap ">
                  <div class="logo-section ">
                    <div class="image">
                      <a href="Landing.html">
                        <img src={headerLogo} alt="header logo" />
                      </a>
                    </div>
                  </div>
                  <div class="call-section">
                    <div class="phone-no">
                      <a href="tel:(800) 820-6020">(800) 820-6020</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* <!-- end-header --> */}

        <main>
          <section class="get-a-free" id="">
            <div class="row ">
              <div class="container">
                <div class="free-solt">
                  <div class="video-pop wow fadeInLeft">
                    <div class="video-title">
                      <p class="getting">
                        <span class="get-a-free-text">GET A FREE</span>
                        <span class="snap-tit">SNAPSHOT VIDEO</span>
                      </p>
                    </div>
                  </div>
                  <div class="des-pop wow fadeInRight">
                    <p>
                      Bring your newsletter or update to life with a quick,
                      compelling video that engages your audience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          
          <WelSnapVideo />
          <ExampleVideos />

          <GetYourFree />

          <WantToDiscuss />
        </main>

        {/* <!--footer--> */}
        <footer id="footer" class="landing-footer">
          <div class="row">
            <div class="container">
              <div class="copyright-container-wrap">
                <p>
                  {" "}
                  © 2025 <a href="Landing.html"> Snapshot Videos </a> - All
                  Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </footer>
      </div>
      {/* <a onclick="topFunction()" id="myBtn" style={{display: "block"}}><i class="fa fa-angle-up"></i></a> */}
      <a onClick={scrollToTop} id="myBtn" style={{ display: showScroll ? "flex" : "none", justifyContent: 'center', alignItems: 'center' }}><KeyboardArrowUp fontSize="large" /></a>
    </>
  );
}

export default FreeVideo;
